export function openLinkInNewWindow(e) {
    e.preventDefault();
    window.open($(this).attr('href'), '_blank');
}

export function getUitkReactIconNameFromTopic(topic){
    const iconMap = {
        //v1 categories - can remove after full cut-over
        'alerts': 'warning',
        'flights': 'flight',
        'hotels': 'lob_hotels',
        'cars': 'lob_cars',
        'trips': 'receipt',
        'trains': 'train',
        'travel_documents_loyalty_points': 'receipt',
        'accounts_settings': 'settings',
        'invoices_expenses': 'credit_card',
        'travel_manager': 'account_circle',
        'booking_for_others': 'people',
        //v2 categories
        'getting_started_admin': 'egencia', // Getting started for travel managers and administrators
        'getting_started_traveler': 'egencia',
        'booking_flights': 'flight',
        'booking_hotels': 'lob_hotels',
        'booking_trains': 'train',
        'booking_cars': 'lob_cars',
        'cancel_booking': 'egencia', // Changing and cancelling a booking
        'other_booking': 'people', // Booking for others
        'reporting': 'egencia',
        'user_profiles': 'egencia',
        'getting_started_approvers': 'egencia',
        'manage_company_settings': 'settings',
        'travel_policy': 'egencia',
        'trip_approval': 'egencia',
        'manage_invoice': 'credit_card',
        'integrations': 'egencia',
        'security_management': 'security',
        'getting_started_arrangers': 'egencia',
        'travel_risk_management': 'egencia',
        'contacting_egencia': 'egencia',
    }
    
    return iconMap[topic.toLowerCase()] || '';
}